<script>
</script>

<div class="shareable-card">
  <h1>The Houston Budget is <br /><strong>complicated.</strong></h1>
  <h2>
    But I did the research, so I know what I support in FY23. <strong
      >Do you?</strong
    >
  </h2>

  <span class="shareable-card-footer"
    >Make your voice heard at <strong>houstonbudget.cool</strong></span
  >
</div>

<style>
  h1 {
    position: absolute;
    top: 25%;
    font-size: 5.5vw;
    font-weight: 200;
    left: 1.5vw;
    line-height: 1.1;
  }

  h2 {
    position: absolute;
    top: 60%;
    right: 1.5vw;
    font-weight: 200;
    font-size: 3.25vw;
    max-width: 65%;
    text-align: right;
    line-height: 1.15;
  }
</style>
